<template>
  <v-row no-gutters class="tw:mt-6 tw:p-2.5 tw:bg-gray-50 tw:border tw:border-gray-100 tw:rounded-base">
    <v-col class="tw:text-left tw:flexcol-3.5">
      <div class="tw:font-medium tw:text-sm tw:flexrow-2 tw:items-center">
        <span>{{ $i18n.t('sidebar.temporaryLayers') }}</span>
        <v-tooltip bottom color="font">
          <template #activator="{ on }">
            <v-icon size="18" v-on="on" color="var(--tw-color-gray-500)">mdi-help-circle</v-icon>
          </template>
          {{ $i18n.t('sidebar.temporaryLayersInfo') }}
        </v-tooltip>
      </div>
      <div>
        <temporary-layers-list-item v-for="layer in layers" :key="layer.id" :metadata="layer" />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import TemporaryLayersListItem from '@/components/TemporaryLayersListItem';

export default {
  name: 'TemporaryLayersList',
  components: {
    TemporaryLayersListItem,
  },
  props: {
    layers: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
